import { PlusOutlined } from '@ant-design/icons';
import { Grid } from 'antd';
import { Button, ContentTopBar } from 'components';
import { AddNotificationModal } from 'features/notification/components/modal/add-notification-items-modal';
import { useState } from 'react';
import { CompanyType } from 'types';
const { useBreakpoint } = Grid;

export const NotificationListTopBar = ({
  initialValues,
  handleFilter,
  form,
}: any) => {
  useState<CompanyType>();
  const screens = useBreakpoint();

  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <ContentTopBar
        title={'Notification List'}
        renderButtons={
          <>
            <Button
              icon={!screens.xs ? <PlusOutlined /> : undefined}
              onClick={() => {
                setShowModal(true);
                document.body.style.overflow = 'hidden';
              }}
            >
              Add Notification
            </Button>
            {showModal && (
              <AddNotificationModal
                onClose={() => setShowModal(false)}
                initialValues={initialValues}
                handleFilter={handleFilter}
                filterForm={form}
              />
            )}
          </>
        }
      />
    </>
  );
};
